import { useIntl } from 'react-intl';
import { memo, useState } from 'react';
import ContactFormModalWithSuccess from '../ContactFormModal/ContactFormModalWithSuccess';
import MenuItem from './MenuItem';

const ContactModalMenuItem = () => {
    const intl = useIntl();
    const [showContactForm, setShowContactFrom] = useState(false);
    return (
        <>
            <MenuItem
                onClick={() => {
                    setShowContactFrom(true);
                }}
                text={intl.formatMessage({
                    id: 'contact',
                })}
            />
            {showContactForm && (
                <ContactFormModalWithSuccess
                    handleClose={() => {
                        setShowContactFrom(false);
                    }}
                />
            )}
        </>
    );
};

export default memo(ContactModalMenuItem);
